<div class="px-4 pt-4 pb-2">
  <div class="mb-3">
    <div class="flex items-center justify-between mb-2">
      <span class="eko-sidebar-section-label">
        {{ 'views.app.data.subject' | translate }}
      </span>
      <button
        class="p-1.5 text-gray-500 hover:text-primary-600 dark:hover:text-primary-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-all duration-200"
        (click)="navigateToManagement()"
        [pTooltip]="'views.app.manageEntities' | translate"
        tooltipPosition="top">
        <i class="pi pi-cog text-sm"></i>
      </button>
    </div>

    <p-skeleton *ngIf="loadingCompanies$ | async" height="40px" borderRadius="8px"></p-skeleton>

    <div *ngIf="(loadingCompanies$ | async) === false && companies.length === 0"
         class="flex items-center gap-3 py-2 text-gray-600 dark:text-gray-400 text-sm">
      <i class="pi pi-building text-gray-400"></i>
      <span>Brak podmiotów</span>
    </div>

    <div *ngIf="(loadingCompanies$ | async) === false && companies.length > 0"
         class="relative">
      <p-select
        [options]="companies"
        [ngModel]="(selectedCompany$ | async) ?? []"
        (ngModelChange)="onChangeCompany($event)"
        [filter]="true"
        filterBy="name"
        styleClass="w-full company-dropdown"
        appendTo="body"
        panelStyleClass="company-panel">

        <ng-template let-item pTemplate="selectedItem">
          <div class="flex items-center gap-3 py-1">
            <div class="w-8 h-8 rounded-full overflow-hidden bg-primary-100 dark:bg-primary-900 flex items-center justify-center">
              <img
                src="https://ui-avatars.com/api/?size=32&background=597A4F&color=ffffff&name={{ item?.name }}"
                class="w-full h-full object-cover"
                [alt]="item?.name" />
            </div>
            <div class="flex-1 min-w-0">
              <div class="font-medium text-gray-900 dark:text-gray-100 truncate">{{ item?.name }}</div>
            </div>
          </div>
        </ng-template>

        <ng-template let-item pTemplate="item">
          <div class="flex items-center gap-3 p-2">
            <div class="w-8 h-8 rounded-full overflow-hidden bg-primary-100 dark:bg-primary-900 flex items-center justify-center">
              <img
                src="https://ui-avatars.com/api/?size=32&background=597A4F&color=ffffff&name={{ item?.name }}"
                class="w-full h-full object-cover"
                [alt]="item?.name" />
            </div>
            <div class="flex-1 min-w-0">
              <div class="font-medium text-gray-900 dark:text-gray-100 truncate">{{ item?.name }}</div>
            </div>
          </div>
        </ng-template>
      </p-select>
    </div>
  </div>

  <div class="mt-3">
    <span class="eko-sidebar-section-label mb-2 block">
      {{ 'views.app.data.year' | translate }}
    </span>
    <form [formGroup]="form">
      <p-select
        class="w-full year-dropdown"
        [options]="availableYears"
        formControlName="year"
        (onChange)="onChangeYear($event)"
        styleClass="w-full">
        <ng-template let-item pTemplate="selectedItem">
          <div class="flex items-center gap-2">
            <i class="pi pi-calendar text-primary-600 dark:text-primary-400"></i>
            <span class="font-medium">{{ item }}</span>
          </div>
        </ng-template>
        <ng-template let-item pTemplate="item">
          <div class="flex items-center gap-2">
            <i class="pi pi-calendar text-gray-500"></i>
            <span>{{ item }}</span>
          </div>
        </ng-template>
      </p-select>
    </form>
  </div>
</div>
